// extracted by mini-css-extract-plugin
export default {"wrapper":"DefautLayout_wrapper__BM8WD","content":"DefautLayout_content__+XHvx"};